module.exports = __webpack_public_path__ + "static/media/dark-logo.8258ee51.svg";